export default __webpack_public_path__ + "media/c8975f7226ca262a567820f474315f303c5bd393b09bd86a20ac4e21dcd96e20.svg";